import request from './.request'

/**
 * 设备管理接口
 * */

/**
 *
 * 新增设备（录入）
 * */
export function addDevice(e) {
  return request({
    url: `/device`,
    method: 'post',
    data: e
  })
}

/**
 * 查询某个园区的所有设备
 * @param {number} parkId 园区id
 * @returns
 */
export function getDevicesByParkId(parkId) {
  return request({
    url: `/device/${parkId}?to=park`,
    method: 'get',
  })
}

/**
 * 根据id查询某个设备的详细信息
 * @param {number} id
 * @returns
 */
export function getDeviceById(id) {
  return request({
    url: `/device/${id}`,
    method: 'get',
  })
}

/**
 * 设置灌溉水肥一体化设备与具体地块相关联
 * @param {number} id 设备id
 * @param {*} relation 控制通道与地块的关联，形如[{landId:0, route:0}, ...]
 * @returns
 */
export function setIrrigateDeviceToLand(id, relation) {
  return request({
    url: `/device/${id}?about=irrigate&to=land`,
    method: 'put',
    data: relation
  })
}

/**
 * 设置设施成套设备与具体地块相关联
 * @param {number} id 设备id
 * @param {number} landId 地块id
 * @returns
 */
export function setFacilityDeviceToLand(id, landId) {
  return request({
    url: `/device/${id}?to=land&landId=${landId}`,
    method: 'put',
  })
}
/**
 * 获取某个灌溉水肥一体化设备与地块关联的信息
 * @param {number} id 设备id
 */
export function getIrrigateRelationsByDeviceId(id) {
  return request({
    url: `/device/${id}/irrigate-relations`,
    method: 'get',
  })
}

/**
 * 根据 园区id查询设备编号
 * */
export function getDeviceInfoByPark(parkId) {
  return request({
    url: `/device/${parkId}?to=park`,
    method: 'get',
  })
}

/**
 * 根据 园区id查询添加编号
 * */
export function setParkDeviceSn(e) {
  return request({
    url: `/device?to=park`,
    method: 'post',
    data:e
  })
}

/**
 * 根据园区园区id修改添加编号
 * */
export function updateParkDeviceSn(e) {
  return request({
    url: `/device/${e.id}?to=park`,
    method: 'put',
    data:e
  })
}

/**
 * 根据地块id查询设备编号
 * */
export function getDeviceInfoByLand(landId) {
  return request({
    url: `/device/${landId}?to=land`,
    method: 'get',
  })
}

/**
 * 根据地块id添加设备
 * */
export function setDeviceInfoByLand(e) {
  return request({
    url: `/device?to=land`,
    method: 'post',
    data:e
  })
}

/**
 * 根据地块id更新设备
 * */
export function updateInfoByland(e) {
  return request({
    url: `/device?to=land`,
    method: 'put',
    data:e
  })
}

/**
 * 查询配置的可控设备
 * */
export function getControlDevice(landId) {
  return request({
    url: `/device/${landId}?of=controller_device`,
    method: 'get',
  })
}

/**
 * 添加配置的可控设备
 * */

export function addControlDevice(e) {
  return request({
    url: `/device?of=controller_device`,
    method: 'post',
    data:e
  })
}
/**
 * 修改配置的可控设备
 * */
export function updateControlDevice(e) {
  return request({
    url: `/device?of=controller_device`,
    method: 'put',
    data:e
  })
}
/**
 * 删除配置的可控设备
 * */
export function delControlDevice(id) {
  return request({
    url: `/device/${id}?of=controller_device`,
    method: 'delete',
  })
}

/**
 * 查询摄像头配置
 * */
export function getCamera(landId) {
  return request({
    url: `/device/${landId}?of=camera_device`,
    method: 'get',
  })
}

/**
 * 摄像头配置
 * */
export function addCamera(e) {
  return request({
    url: `/device?of=camera_device`,
    method: 'post',
    data:e
  })
}
/**
 *查询摄像拍照信息
 * */
export function getInfoByCamera(landId,e) {
  return request({
    url: `/device/${landId}?of=camera_device_pic`,
    method: 'get',
    params:e
  })
}



// WEBPACK FOOTER //
// ./src/api/equip.js